import React, { useState, useEffect } from 'react';
import Title from "../../containers/title/title";
import Gallery from "../../containers/gallery/gallery";
import Form from './form/form';
import classes from "./teamBuilding.module.css"
import Card from '../card/card';

const TeamBuilding = (props) => {
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [selectedFood, setSelectedFood] = useState([]);
  const toggleActivitiesSelection = (id) => {
    if (selectedActivities.includes(id)) {
      setSelectedActivities(selectedActivities.filter(selected => selected !== id));
    } else {
      setSelectedActivities([...selectedActivities, id]);
    }
  };
  const toggleLiveStationSelection = (item) => {
    let liveStation = { item_id: item.id, quantity: item.quantity, category: 'packages' };
    const existingItem = selectedFood.find(selected => selected.category === liveStation.category);
    if (existingItem) {
      if (existingItem.item_id === liveStation.item_id) {
        setSelectedFood(selectedFood.filter(selected => selected.item_id !== liveStation.item_id));
      } else {
        setSelectedFood(selectedFood.filter(selected => selected.item_id !== existingItem.item_id).concat(liveStation));
      }
    } else {
      setSelectedFood([...selectedFood, liveStation]);
    }
  };
  return (
    <div className={classes.Container}>
      <div className={classes.HeroImage} />
      <div className={classes.Description}>
        {parseInt(localStorage.getItem('language')) === 1 
            ? "Ready to take a fun break from work and bond up with your mates" 
            : "هل أنت مستعد لأخذ استراحة ممتعة من العمل والتواصل مع زملائك"}
      </div>
      <Title 
        title={parseInt(localStorage.getItem('language')) === 1 ? "LET'S PLAN THE DAY" : "دعنا نخطط لليوم"} 
        isTeamBuilding 
      />
      <p className={classes.FormDescription}>
        {parseInt(localStorage.getItem('language')) === 1 
            ? "Fill up the form and submit it and we will contact you shortly" 
            : "املأ النموذج وأرسله وسنتواصل معك قريباً"}
      </p>
      <div className={classes.StepTitle}>
        {parseInt(localStorage.getItem('language')) === 1 
            ? "Step1: Choose the activities you want" 
            : "الخطوة ١: اختر الأنشطة التي تريدها"}
      </div>
      {props.teamBuildingTypes?.activities?.length > 0 && <ul className={classes.List}>{props.teamBuildingTypes?.activities?.map((activity) =>
        <Card key={activity.id} name={activity.name} image={activity.image}
          onClick={() => toggleActivitiesSelection(activity.id)}
          class={selectedActivities.find((selected) => selected === activity.id) ? "Selected" : ''} />)
      }
      </ul>}
      <div className={classes.StepTitle}>
        {parseInt(localStorage.getItem('language')) === 1 
            ? "Step 2 (optional): Choose Cake & Food" 
            : "الخطوة ٢ (اختياري): اختر الكيك والطعام"}
      </div>
      {props.cakes?.length > 0 && <>
        <div className={classes.ListTitle}>
            {parseInt(localStorage.getItem('language')) === 1 ? "Cake" : "كيك"}
        </div>
        <ul className={classes.List}>{props.cakes?.map((food) =>
          <Card key={food.id} hasCounter id={food.id} name={food.name} image={food.image}
            people={food.serves_people} setSelectedFood={setSelectedFood} selectedFood={selectedFood} />
        )}
        </ul>
      </>}
      {props.pizza?.length > 0 && <>
        <div className={classes.ListTitle}>
            {parseInt(localStorage.getItem('language')) === 1 ? "Pizza" : "بيتزا"}
        </div>
        <ul className={classes.List}>{props.pizza?.map((food) =>
          <Card key={food.id} hasCounter id={food.id} name={food.name} image={food.image}
            people={food.serves_people} setSelectedFood={setSelectedFood} selectedFood={selectedFood} />
        )}</ul>
      </>}
      {props.pasta?.length > 0 && <>
        <div className={classes.ListTitle}>
            {parseInt(localStorage.getItem('language')) === 1 ? "Pasta" : "باستا"}
        </div>
        <ul className={classes.List}>{props.pasta?.map((food) =>
          <Card key={food.id} hasCounter id={food.id} name={food.name} image={food.image}
            people={food.serves_people} setSelectedFood={setSelectedFood} selectedFood={selectedFood} />
        )}</ul>
      </>}
      {props.burgers?.length > 0 && <>
        <div className={classes.ListTitle}>
            {parseInt(localStorage.getItem('language')) === 1 ? "Burgers & Tenders" : "برجر وتندرز"}
        </div>
        <ul className={classes.List}>{props.burgers?.map((food) =>
          <Card key={food.id} hasCounter id={food.id} name={food.name} image={food.image}
            people={food.serves_people} setSelectedFood={setSelectedFood} selectedFood={selectedFood} />
        )}
        </ul></>}
      {props.packages?.length > 0 && <>
        <div className={classes.ListTitle}>
            {parseInt(localStorage.getItem('language')) === 1 ? "Live Stations" : "محطات الطعام المباشرة"}
        </div>
        <ul className={classes.List}>{props.packages?.map((liveStation) =>
          <Card key={liveStation.id} liveStations shawerma={liveStation.shawerma}
            burger={liveStation.burger} id={liveStation.id} fries={liveStation.fries} image={liveStation.image}
            onClick={() => toggleLiveStationSelection(liveStation)}
            setSelectedFood={setSelectedFood} selectedFood={selectedFood} />)
        }
        </ul>
      </>}
      {props.snacks?.length > 0 && <>
        <div className={classes.ListTitle}>
            {parseInt(localStorage.getItem('language')) === 1 ? "Snacks" : "وجبات خفيفة"}
        </div>
        <ul className={classes.List}>{props.snacks?.map((food) =>
          <Card key={food.id} hasCounter id={food.id} name={food.name} image={food.image}
            people={food.serves_people} setSelectedFood={setSelectedFood} selectedFood={selectedFood} />
        )}
        </ul></>}
      <div className={classes.StepTitle}>
        {parseInt(localStorage.getItem('language')) === 1 
            ? "Step 3: Fill up the form" 
            : "الخطوة ٣: املأ النموذج"}
      </div>
      <Form availableSlots={props.teamBuildingTypes?.available_slots}
        selectedActivities={selectedActivities}
        selectedFood={selectedFood} 
        isAuthenticated={props.isAuthenticated}
        setShowLoginForm={props.setShowLoginForm}/>
      {props.imageList?.length > 0 && <>
        <Title title={parseInt(localStorage.getItem('language')) === 1 ? "GALLERY" : "معرض الصور"} isBirthday />
        <Gallery images={props.imageList} />
      </>}
    </div>
  )
}
export default TeamBuilding;